<div id="client-activity-log" class="container-fluid">

    <mat-card class="screen-sized-card">

        <mat-card-title>
            <div class="row">
                <div class="col-sm-12">
                    {{ 'log.case_activity_log.breadcrumb' | translate }}
                </div>
            </div>
        </mat-card-title>

        <mat-card-content class="mt-4 screen-sized-card-content">

            <!-- SEARCH PARAMETERS -->

            <div class="row">

                <div class="col-sm-10">

                    <div class="row">

                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>{{ 'common.label.search' | translate }}</mat-label>
                                <input type="text" matInput
                                       id="{{idPrefix}}filter.input_text.search"
                                       [(ngModel)]="searchText"
                                       (keydown.enter)="applyFilters()">
                                <button mat-button
                                        matSuffix mat-icon-button
                                        aria-label="'common.label.search' | translate"
                                        id="{{idPrefix}}filter.btn.clear_search"
                                        *ngIf="searchText"
                                        (click)="searchText = ''; applyFilters()">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>


                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>{{ 'common.label.category' | translate }}</mat-label>
                                <mat-select id="{{idPrefix}}filter.input_select.category"
                                            [(ngModel)]="selectedLogCategory"
                                            [disabled]="disabled"
                                            (ngModelChange)="applyFilters()">
                                    <mat-option id="{{idPrefix}}filter.input_select.category.{{category.key}}"
                                                *ngFor="let category of logCategories"
                                                [value]="category.key"
                                                [disabled]="categoryUnAvailable(category)">
                                        {{ category.trans | translate }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>{{ 'common.label.user' | translate }}</mat-label>
                                <mat-select id="{{idPrefix}}filter.input_select.user_id"
                                            [(ngModel)]="selectedUserId"
                                            [disabled]="disabled"
                                            (ngModelChange)="applyFilters()">
                                    <mat-option id="{{idPrefix}}filter.input_select.user_id.{{user.id}}"
                                                *ngFor="let user of userList?.items"
                                                [value]="user.id"
                                                [disabled]="userUnAvailable(user)">
                                        {{ user.user_code | translate }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                    </div>
                </div>

                <div class="col-sm-2">
                    <button mat-raised-button class="full-width filter-button"
                            id="{{idPrefix}}filter.btn.reset_filters"
                            (click)="resetFilters(); applyFilters()"
                            [disabled]="filterIsDefault">
                        {{ 'common.btn.reset_filters' | translate }}
                    </button>
                </div>

            </div>


            <!-- ACTIVITY LOG ROWS -->

            <log-table [logs]="logs" [idPrefix]="idPrefix"></log-table>


        </mat-card-content>

    </mat-card>

</div>
